<template>
  <div>
    <navbar/>
    <error-panel showInPopup="false" />
    <Spinner :loaded="loaded" />
    <main role="main" v-if="loaded">
        <div class="jumbotron" id="tl-jumbotron">
          <div class="container">
            <div class="row tl-link-block tl-link-block-header pb-1 mb-3">
              <h4 class="col-12"><span class="bi bi-person-vcard mr-2"/>My Profile</h4>
            </div>

            <div v-if="loaded" class="row tl-link-block p-4">
              <div class="col-12">
                <div class="row d-flex justify-content-center pb-2">
                  <div class="col-sm-6">
                    <div v-if="paymentSuccess" class="container alert alert-success alert-dismissible fade show" role="alert">
                      Thanks for subscribing! Please note that syncing your billing status may take a couple of seconds...
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="form-label-group">
                      <input
                              id="userName"
                              type="text"
                              :value="userProfile.userName + ' (' + userProfile.userId + ')'"
                              readonly="true"
                              class="form-control disabled"/>

                      <label for="userName">User name (id)</label>
                    </div>
                  </div>
                </div>
                <div class="row d-flex justify-content-center">
                  <div class="col-sm-6">
                    <div class="form-label-group">
                      <input
                              id="email"
                              type="text"
                              :value="userProfile.email"
                              readonly="true"
                              class="form-control disabled"/>

                      <label for="email">Email address</label>
                    </div>
                  </div>
                </div>
                <div class="row d-flex justify-content-center">
                  <div class="col-sm-6">
                    <div class="form-label-group">
                      <input
                              id="registeredAt"
                              type="text"
                              :value="formatDate(userProfile.registeredAt)"
                              readonly="true"
                              class="form-control disabled"/>

                      <label for="registeredAt">Registration time</label>
                    </div>
                  </div>
                </div>
                <div class="row d-flex justify-content-center">
                  <div class="col-sm-6">
                    <div class="form-label-group">
                      <input
                              id="status"
                              type="text"
                              :value="formattedStatus(userProfile.status).text"
                              readonly="true"
                              class="form-control disabled"/>

                      <label for="status"><span class="bi bi-circle-fill" :class="formattedStatus(userProfile.status).styleClass"></span> Account status</label>
                    </div>
                  </div>
                </div>
                <div class="row d-flex justify-content-center" v-if="!!userProfile.paymentEndTime">
                  <div class="col-sm-6">
                    <div class="form-label-group">
                      <input
                              id="paymentEndTime"
                              type="text"
                              :value="formatDate(userProfile.paymentEndTime)"
                              readonly="true"
                              class="form-control disabled"/>

                      <label for="paymentEndTime">Paid until</label>
                    </div>
                  </div>
                </div>

                <div class="row d-flex justify-content-center" v-if="userProfile.status !== 'PAID'">
                  <div class="col-sm-6">

                    <div class="card h-100" >
                      <div class="card-body text-center">
                        <h6 class="card-title pb-4">Subscribe to continue using just bookmark it!</h6>
                        <p class="card-text pb-0">
                          <span class="text-muted">Access all features for</span> <br/>
                          <span style="font-size: 1.3em" class="text-primary"><b>$1.79</b> / month</span> <br/>  <small class="text-muted">(VAT or local sales taxes may apply)</small>

                        </p>

                        <spinner-button
                                :spinning="checkOutRequestInProgress"
                                class="btn-primary"
                                @click="startCheckout()">
                          <span class="bi bi-cart4"></span> Order now
                        </spinner-button>

                      </div>
                    </div>


                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
    </main>
    <tlfooter v-if="loaded"/>
  </div>
</template>

<script>
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";
import ErrorPanel from "@/components/ErrorPanel";
import BackendClient from "@/rest/backend-client";
import Spinner from "@/components/Spinner";
import moment from 'moment';
import SpinnerButton from "@/components/SpinnerButton";

const STATUSES = {
  "LIFETIME_FREE": {text: "Lifetime free access", styleClass: "text-success"},
  "TRIAL_ENDED": {text: "Trial ended", styleClass: "text-danger"},
  "TRIALLING": {text: "Trialling", styleClass: "text-info"},
  "PAID": {text: "Paid", styleClass: "text-success"},
  "EXPIRED": {text: "Payment expired", styleClass: "text-danger"},
};

export default {
  name: "UserProfilePage",
  head: {
    title: 'just bookmark it! - my profile'
  },
  components: { ErrorPanel, navbar, tlfooter, Spinner, SpinnerButton },
  props: ['paymentSuccess'],
  data() {
    return {
      backendClient: new BackendClient(),
      loaded: false,
      userProfile: null,
      checkOutRequestInProgress: false
    };
  },

  mounted() {
    this.backendClient.getUserProfile().then(responseData => {
        this.userProfile = responseData.data;
    }).finally(() => {
        this.loaded = true;
    });
  },

  computed: {

  },

  methods: {
    formatDate(date) {
        let inputDate = moment(date);
        return inputDate.format('DD-MM-yyyy HH:mm');
    },
    formattedStatus(status) {
      return STATUSES[status] || { text: status, styleClass: "" }
    },
    startCheckout() {
      this.checkOutRequestInProgress = true;

      this.backendClient.startCheckout().then(responseData => {
        window.location.replace(responseData.data);
      }).catch(() => {
        this.checkOutRequestInProgress = false;
    });
    }
  }
};
</script>
<style>
  .bi-person-vcard {
    color: deepskyblue;
  }
</style>
